import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestSection() {
  const latestArticles = getLatestArticles(8);

  return (
    <section id="latest" className="bg-background-100/70 py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              最新爆料
            </h2>
            <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">NEW</span>
          </div>
          <p className="text-sm text-foreground-500">最新鲜的瓜，第一时间呈现给你</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-28 h-24 md:w-36 md:h-28 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <span className="text-xs text-primary-600 font-medium">{article.categoryName}</span>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mt-1 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2 hidden md:block">{article.excerpt}</p>
                </div>
                <div className="flex items-center gap-4 mt-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line"></i>{article.publishDate}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>{(article.viewCount / 10000).toFixed(0)}万阅读
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-message-2-line"></i>{article.commentCount}评
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/star-scandal"
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-300 text-foreground-700 font-medium rounded-lg hover:bg-background-200 transition-all duration-200 whitespace-nowrap"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}